// extracted by mini-css-extract-plugin
export default {"highlight":"HighlightCard_highlight__HusAw","textGroup":"HighlightCard_textGroup__61LsJ"};